var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","pa-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n    Prepared items\n  ")]),_c('v-flex',[_c('list',{attrs:{"items":_vm.filteredItems,"view-type":"bump-out"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }